var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.precent)?_c('div',{staticClass:"RoundProgress"},[_c('div',{staticClass:"circle"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"progress",style:({
          width: _vm.precent+'%',
          height: _vm.precent+'%',
          background: ("rgba(" + (_vm.precent/3) + ", " + (_vm.precent*2) + ", " + (_vm.precent/1.5) + ", 0.8)")
        })})]),(_vm.precent < 100)?_c('p',[_vm._v(_vm._s(_vm.precent)+" %")]):_c('p',{staticStyle:{"font-size":"32rem"}},[_vm._v("✔")])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }